export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "ddef492835msh56ec8bfc180992dp12a854jsn6adf66576296",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "7f193314ca0f996be28e2a756c2fc9d3";
